import {useMutation} from '@apollo/react-hooks';

import type {
    CreateContactForCoreEntity as CreateContactForCoreEntityMutation,
    CreateContactForCoreEntityVariables as CreateContactForCoreEntityMutationVariables,
    ContactCreateInput,
} from 'nutshell-graphql-types';

import CREATE_CONTACT_FOR_CORE_ENTITY from '../mutations/create-contact-for-core-entity.graphql';

interface CreateContactForCoreEntityOptions {
    refetchQueries: any[];
}

export function useCreateContactForCoreEntity(options?: CreateContactForCoreEntityOptions): {
    createContactForCoreEntity: (input: ContactCreateInput) => Promise<any>;
    isLoading: boolean;
} {
    const [createContactForCoreEntity, {loading}] = useMutation<
        CreateContactForCoreEntityMutation,
        CreateContactForCoreEntityMutationVariables
    >(CREATE_CONTACT_FOR_CORE_ENTITY);

    return {
        createContactForCoreEntity: (input: ContactCreateInput) => {
            return createContactForCoreEntity({
                variables: {input},
                refetchQueries: options?.refetchQueries,
                awaitRefetchQueries: true,
            });
        },
        isLoading: loading,
    };
}
